// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
export { ApplicationInsights } from "./JavaScriptSDK/ApplicationInsights";
//# sourceMappingURL=applicationinsights-analytics-js.js.map